module.exports = __webpack_public_path__ + "media/images/pr_detail/time-f2a0e49902504b36450ba616b4fdb6a7.png";